import { useEffect, useState } from "react";
import styles from "../styles/herocarousel.module.css";

const BASE = `${process.env.PUBLIC_URL}/backgroundimg/`;

// The full pool in public/backgroundimg — the folder isn't bundled, so the
// names live here. Add a file to the folder, add its name below.
const POOL = [
    "img_2.jpg", "img_3.jpg", "img_4.jpg",
    "img_5.jpg", "img_6.jpg", "img_7.jpg",
];

const SLIDE_COUNT = POOL.length;
const INTERVAL = 4500;

// Fisher–Yates on a copy, then take the first n — a fresh set each page load.
function pickSlides(n) {
    const deck = [...POOL];
    for (let i = deck.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [deck[i], deck[j]] = [deck[j], deck[i]];
    }
    return deck.slice(0, n);
}

export default function HeroCarousel({ className }) {
    const [active, setActive] = useState(0);
    const [SLIDES] = useState(() => pickSlides(SLIDE_COUNT));

    // Keyed on `active`: any change — auto-advance, arrow, or dot — cancels the
    // pending timer and arms a fresh one, so a click always buys a full
    // interval on the slide it lands on instead of inheriting the remainder.
    useEffect(() => {
        const reduce = window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) return;

        const id = setTimeout(() => {
            setActive((prev) => (prev + 1) % SLIDES.length);
        }, INTERVAL);
        return () => clearTimeout(id);
    }, [active, SLIDES.length]);

    const go = (step) =>
        setActive((prev) => (prev + step + SLIDES.length) % SLIDES.length);

    return (
        <div className={`${className} ${styles.frame}`}>
            <div className={styles.window}>
                {SLIDES.map((src, idx) => (
                    <img
                        key={src}
                        src={BASE + src}
                        alt=""
                        aria-hidden={idx !== active}
                        className={`${styles.slide} ${idx === active ? styles.active : ""}`}
                        loading={idx === 0 ? "eager" : "lazy"}
                    />
                ))}
            </div>

            <button
                type="button"
                className={`${styles.arrow} ${styles.arrowPrev}`}
                onClick={() => go(-1)}
                aria-label="Previous view"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M15 4 L7 12 L15 20" />
                </svg>
            </button>

            <button
                type="button"
                className={`${styles.arrow} ${styles.arrowNext}`}
                onClick={() => go(1)}
                aria-label="Next view"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M9 4 L17 12 L9 20" />
                </svg>
            </button>

            <div className={styles.dots} role="tablist" aria-label="Sample views">
                {SLIDES.map((_, idx) => (
                    <button
                        key={idx}
                        type="button"
                        className={`${styles.dot} ${idx === active ? styles.dotOn : ""}`}
                        onClick={() => setActive(idx)}
                        aria-label={`Show sample ${idx + 1}`}
                        aria-selected={idx === active}
                    />
                ))}
            </div>
        </div>
    );
}
